import { useContext } from 'react';
import { ResponsiveContext, ScreenType } from 'contexts/Responsive';
const useScreenType = (): ScreenType => {
  const screenType = useContext(ResponsiveContext);
  if (screenType === undefined) {
    throw new Error('useScreenType must be used within a ResponsiveProvider');
  }
  return screenType;
};
export { useScreenType };
